module.exports = __webpack_public_path__ + "fonts/Decimal-Medium.fb29c63.woff";